<template lang="pug">
section.section
  transition(name="long-fade")
    .container(v-if="posts")
      .columns
        .column.is-offset-2-desktop.is-8-desktop.is-offset-1-tablet.is-10-tablet
          .columns.is-centered
            .column.is-half-tablet
              a.button.is-primary.is-fullwidth.is-uppercase(@click='addPost') {{ postButtonText }}

          list-row(v-for="post in allPosts"
            :key="post.id"
            :title="post.title"
            :subtitle="post.created_at | relative"
            icon="calendar-week"
            :item="post"
            v-on:action="showPost")
</template>

<script>
import POST_LIST from '@/graphql/posts/list.gql'
import MY_POST from '@/graphql/posts/mine.gql'
import ListRow from '@/components/ListRow'
import moment from 'moment'

export default {
  components: {
    ListRow
  },

  mounted () {
    window.scrollTo(0, 0)
    window.onscroll = () => {
      const position = Math.max(window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop)
      const outerPosition = position + window.innerHeight
      const atBottom = outerPosition === document.documentElement.offsetHeight
      if (atBottom) this.fetchMore()
    }
  },

  data () {
    return {
      posts: null,
      myPost: null,
      allPosts: [],
      page: 1,
      rowsPerPage: 25
    }
  },

  computed: {
    offset () {
      return (this.page - 1) * this.rowsPerPage
    },
    postButtonText () {
      return this.myPost ? 'Edit My Need' : 'Post A Critical Need'
    }
  },

  filters: {
    relative: function (time) {
      return 'Posted: ' + moment(time).fromNow()
    }
  },

  apollo: {
    posts: {
      query: POST_LIST,
      variables () {
        return {
          offset: this.offset,
          limit: this.rowsPerPage,
          now: new Date()
        }
      },
      update ({ posts }) {
        posts.forEach(post => {
          if (!this.allPosts.find(existing => existing.id === post.id)) {
            this.allPosts.push(post)
          }
        })
        this.hasMore = posts.length === this.rowsPerPage
        return posts
      }
    },
    myPost: {
      query: MY_POST,
      skip () {
        return !this.$auth.user
      },
      variables () {
        return {
          user_id: this.$auth.user.id,
          now: new Date()
        }
      },
      update (data) {
        return data.posts[0]
      }
    }
  },

  methods: {
    addPost () {
      if (this.myPost) {
        this.$router.push({ name: 'edit-post', params: { id: this.myPost.id } })
      } else {
        this.$router.push({ name: 'new-post' })
      }
    },
    showPost (post) {
      this.$router.push({ name: 'post', params: { id: post.id } })
    },
    fetchMore () {
      if (!this.hasMore) return
      this.hasMore = false
      this.page += 1
    }
  }
}
</script>

<style scoped lang="scss">
.notification {
  padding: 0.75em 2em;
}
</style>
